import axios from "axios";
import store from "../store";
import server from '../config/server'
import qs from "qs";
let baseDomain = `${location.protocol}//${location.host}`;
let qxyRes = "https://res.qxueyou.com/";
const axiosInstance = axios.create({
  baseURL: server.baseUrl,
  timeout: 60000,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
  }
});

const omitList = [
  '/base/file/upload'
]

axiosInstance.interceptors.request.use(
  (config) => {
    if (localStorage.getItem("tokenn")) {
      config.headers["Authorization"] = localStorage.getItem("tokenn");
    }
    if (!omitList.includes(config.url)) {
      config.data = qs.stringify(config.data);
    }
    console.log('url',config.url)
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  response => {
    console.log(response.config.url)
    console.log(response.data)
    return response
  },
  error => {
    if (403 === error.response.status) {
      // store.commit('session/clearUser')
      store.commit('session/logout')
      throw new Error('登录失效')
    }
    return Promise.reject(error)
  }
)
export default axiosInstance;
